import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box, Typography } from '@heycater/design-system';
import Image from 'next/image';
import styled from 'styled-components';

import { useBreakpointDown } from 'qualification/hooks/useBreakpoints';

export default function ImageTextFlexBox({
  alt,
  caption,
  image,
  imageAlign,
  title,
  backgroundColor,
}) {
  const backgroundImage = image?.fields?.file
    ? `https:${image.fields?.file?.url}?w=600`
    : '';

  return (
    <Box style={{ background: backgroundColor || '#FFF' }} my={3}>
      <Box maxWidth={1050} mx="auto">
        <Advantage>
          {backgroundImage && (
            <Box flexShrink="0" order={imageAlign === 'left' ? 0 : 1}>
              <AdvantageImage
                src={backgroundImage}
                priority
                height={250}
                width={450}
                objectFit="cover"
                alt={alt}
              />
            </Box>
          )}
          <Box flexGrow={1}>
            <Box flexDirection="column" display="flex">
              <AdvantageTitle>{title}</AdvantageTitle>
              {caption && (
                <AdvantageDescription>
                  {documentToReactComponents(caption)}
                </AdvantageDescription>
              )}
            </Box>
          </Box>
        </Advantage>
      </Box>
    </Box>
  );
}

function AdvantageImage(props) {
  const isSm = useBreakpointDown('sm');
  const baseWidth = 350;
  const baseHeight = 350;

  return (
    <Image
      src={props.src}
      width={isSm ? baseWidth * 0.8 : baseWidth}
      height={isSm ? baseHeight * 0.8 : baseHeight}
      objectFit="contain"
      alt=""
    />
  );
}

const Advantage = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: start;
  gap: ${({ theme }) => theme.spacing(3)}px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: ${({ theme }) => theme.spacing(9)}px;
    flex-direction: row;
  }
`;

function AdvantageTitle(props) {
  return (
    <Typography
      component="h3"
      fontSize={{ xs: 18, sm: 20, md: 36 }}
      mb={1}
      fontWeight={600}
      {...props}
    />
  );
}

function AdvantageDescription(props) {
  return <Typography fontSize={{ xs: 14, sm: 16 }} {...props} />;
}
